export default __webpack_public_path__ + "static/media/placeholder_chart_horizontal_bar.c75c09a6.svg";